module.exports = __webpack_public_path__ + "img/bls-5.a61615f3.png";